module.exports = __webpack_public_path__ + "img/policing_specialisations_splash.c34c2dcc.jpg";